import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import FieldLabelWrapper from '../../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../../components/Form/Field'
import ObjectiveWarningMessage from '../../../../../../Multiplatform/UploadAdCreative/ObjectiveWarningMessage'

import { getGoalAmountFieldDescription } from '../../../../../campaignHelpers'
import { getObjectiveAmountField } from '../../../../../helpers'
import { getIsObjectiveEquivalentToReach } from '../../../../../../Multiplatform/UploadAdCreative/helpers'

import { selectedDV360AdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'
import { rightSelector } from '../../../../../../../modules/selectors/rights'

import { DIGITAL_ALLOCATION_TYPE_IMPRESSIONS } from '../../../../../../Multiplatform/Partnerships/RightForms/fields'
import {
  OBJECTIVE_PERCENTAGE,
  PERFORMANCE_GOAL_AMOUNT,
  PERFORMANCE_GOAL_TYPE
} from '../../../../../CampaignForms/CampaignDv360Create/CampaignDv360CreateForm/fields'
import { objectivesList } from '../../fields'

const CampaignObjectiveFields = ({ formik }) => {
  const { t } = useTranslation()

  const { currency_symbol: currencySymbol } = useSelector(selectedDV360AdAccountSelector)
  const { allocation_type: rightAllocationType } = useSelector(rightSelector)
  const isImpressionAllocationType = rightAllocationType === DIGITAL_ALLOCATION_TYPE_IMPRESSIONS

  const { values } = formik

  const goalType = values[PERFORMANCE_GOAL_TYPE]

  const isObjectiveEquivalentToReach = getIsObjectiveEquivalentToReach(goalType)

  const objectiveAmountField = getObjectiveAmountField(goalType)

  const goalAmountFieldDescription = useMemo(() => {
    return getGoalAmountFieldDescription(goalType)
  }, [goalType])

  return (
    <FieldLabelWrapper label={t('Campaign goal')}>
      <p>
        {t(
          'To upload the ad to a new campaign, please select the campaign optimisation goal. Please only select ‘CPA’ if you have already linked your conversion pixel.'
        )}
      </p>
      <Field
        name={PERFORMANCE_GOAL_TYPE}
        label="Goal"
        placeholder="Select goal..."
        formik={formik}
        options={objectivesList}
      />
      <p>{goalAmountFieldDescription}</p>
      {isImpressionAllocationType && !isObjectiveEquivalentToReach && <ObjectiveWarningMessage />}
      <Field
        type="number"
        formik={formik}
        name={PERFORMANCE_GOAL_AMOUNT}
        placeholder="Optimization Goal Amount"
        autoComplete="off"
        inputMode="numeric"
        symbol={objectiveAmountField === OBJECTIVE_PERCENTAGE ? '%' : currencySymbol}
        symbolPosition={objectiveAmountField === OBJECTIVE_PERCENTAGE ? 'end' : undefined}
      />
    </FieldLabelWrapper>
  )
}

export default CampaignObjectiveFields
